import Vue from 'vue'
import Router from 'vue-router'
import Online from './online'
import My from './my'
import Account from './account'
import manager from './manager'
import Invoice from './invoice'
import YkfPay from '../pages/ykfpay'
import Book from './book'
import Consult from './consult'
import Wait from './wait'
import home from './home'
import smart from './smart'
import Report from './report'
import TodayBook from './todayBook'
import payment from './payment'
import Ship from './ship'
import manual from './manual'
import Check from './check'
import Medical from './medical'
import bind from './bind'
import navigation from './navigation'
import health from './health'
import Pay from './pay'
import Doc from './doc'
import MedicalRecordCopy from './medicalRecordCopy'
import Renewal from "./renewal"
import Nurse from "./nurse"
import Recipe from "./recipe"
import Public from  "./public"
import PlatReport from "./plat-report"
import Charge from "./charge.js"

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/homePage' // /home   /
    },
    {
      path: '/welcome',
      component: () => import('../pages/welcome')
    },
    {
      path: '/demo',
      component: () => import('../pages/demo')
    },
    {
      name: 'ykfpay',
      path: '/ykfpay',
      meta: {
        title: '支付费用'
      },
      component: YkfPay
    },
    {
      path: '/consultation',
      component: () => import('../pages/consultation.vue')
    },
    /**
     * 聊天
     * @query.followId
     */
    {
      name: 'chat',
      path: '/chat',
      meta: {
        title: '聊天'
      },
      component: () => import('Pages/chat')
    },
    ...health,
    ...Book,
    ...bind,
    ...Report,
    ...TodayBook,
    ...manager,
    ...Online,
    ...My,
    ...Consult,
    ...Account,
    ...Invoice,
    ...Wait,
    ...home,
    ...Ship,
    ...smart,
    ...payment,
    ...manual,
    ...Check,
    ...Medical,
    ...navigation,
    ...Pay,
    ...Doc,
    ...MedicalRecordCopy,
    ...Renewal,
    ...Nurse,
    ...Recipe,
    ...Public,
    ...PlatReport,
    ...Charge
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {x: 0, y: 0}
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js